// // next-i18next.config.js
// module.exports = {
//   i18n: {
//     defaultLocale: "en",
//     locales: ["en", "ar"],
//   },
//   localePath: "./public/locales",
// };

// next-i18next.config.js
const path = require("path");

module.exports = {
  i18n: {
    locales: ["en", "ar"],
    defaultLocale: "en",
    // localeDetection: true, // Optional but recommended
    localeDetection: false, // disable auto redirection
  },
  localePath: path.resolve("./public/locales"), // ✅ ensures compatibility on all OS
};
